import { useContext, useState, useEffect } from 'react';
import { NavLink as RouterLink, useLocation } from 'react-router-dom';
import './navbar.css';
import { Navbar, Nav, NavDropdown, OverlayTrigger, Popover, PopoverContent } from 'react-bootstrap';
import { ShowIf, useSecurity } from './Security/security';
import tm from '../images/registered-clear.svg';
import { StoreContext } from './Store';
import isoDateConverter from './isoDateConverter';
import { wlpContext } from '../store/wlpStore';

const NavbarMenu = () => {
  const store = useContext(StoreContext);
  const { isWLP, logo, navbarFontColour } = useContext(wlpContext);
  const { securityState } = useSecurity();
  const [showNavMenu, setShowNavMenu] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setShowNavMenu(true);
  }, [securityState]);

  const resetLoad = (e) => {
    const isOnNewLoadPage = location.pathname.toLowerCase().startsWith('/newload');
    const isOnUnifiedLoadPage = location.pathname.toLowerCase().startsWith('/load');

    //The new load page now has a confirmation popup that resets the load
    if ((!isOnNewLoadPage && !isOnUnifiedLoadPage) || !store.newLoadDataModified[0]) {
      store.resetNewLoad();
    }
  };

  return (
    <div>
      <Navbar expand="lg" className={navbarFontColour !== '#fff' ? 'shadow shadow-bottom shadow-lg' : ''}>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="container-fluid">
            <Navbar.Brand as={RouterLink} className="eoriLogo" to="/">
              <span>
                <img src={logo} alt="CABIE Logo" />

                {!isWLP && (
                  <span>
                    <img
                      src={tm}
                      style={{
                        height: '1.2rem',
                        width: '1rem',
                        marginLeft: '0.4rem',
                        marginBottom: '2rem',
                      }}
                      alt="tm"
                    />
                  </span>
                )}

                {isWLP && (
                  <span
                    style={{
                      color: navbarFontColour,
                      marginLeft: '30px',
                      fontSize: '12pt',
                    }}
                  >
                    <span className="logo-first-letter" style={{ fontSize: '12pt' }}>
                      P
                    </span>
                    <span style={{ fontSize: '9pt' }}>owered</span> <span style={{ fontSize: '12pt' }}>b</span>
                    <span style={{ fontSize: '9pt' }}>y </span>
                    <span className="logo-first-letter" style={{ fontSize: '12pt' }}>
                      C
                    </span>
                    <span style={{ fontSize: '9pt' }}>ABIE</span>
                    <span>
                      {/* (R) symbol */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        style={{
                          height: '0.9rem',
                          width: '0.9rem',
                          marginLeft: '0.2rem',
                          verticalAlign: 'text-top',
                        }}
                      >
                        <path
                          style={{
                            textIndent: '0px',
                            textAlign: 'start',
                            lineHeight: 'normal',
                            textTransform: 'none',
                            fill: navbarFontColour,
                          }}
                          d="M 12 2 C 6.4889972 2 2 6.4889972 2 12 C 2 17.511003 6.4889972 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889972 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 8.5 7 L 8.5 17 L 10.59375 17 L 10.59375 13.40625 L 12.1875 13.40625 L 14.09375 17 L 16.3125 17 L 16.3125 16.90625 L 14.09375 12.8125 C 14.29375 12.7125 14.6125 12.60625 14.8125 12.40625 C 15.1125 12.20625 15.20625 12.0125 15.40625 11.8125 C 15.60625 11.5125 15.7125 11.3 15.8125 11 C 15.9125 10.7 15.90625 10.4 15.90625 10 C 15.90625 9.5 15.79375 9.0875 15.59375 8.6875 C 15.49375 8.3875 15.20625 8.1125 14.90625 7.8125 C 14.50625 7.5125 14.1875 7.2875 13.6875 7.1875 C 13.2875 7.0875 12.7875 7 12.1875 7 L 8.5 7 z M 10.6875 8.8125 L 12.3125 8.8125 C 12.8125 8.8125 13.2 8.8875 13.5 9.1875 C 13.8 9.4875 13.90625 9.8125 13.90625 10.3125 C 13.90625 10.5125 13.9125 10.70625 13.8125 10.90625 C 13.7125 11.10625 13.6 11.30625 13.5 11.40625 C 13.4 11.50625 13.2 11.5875 13 11.6875 C 12.8 11.7875 12.6125 11.8125 12.3125 11.8125 L 10.6875 11.8125 L 10.6875 8.8125 z"
                          overflow="visible"
                          enableBackground="accumulate"
                          fontFamily="Bitstream Vera Sans"
                        />
                      </svg>
                    </span>
                  </span>
                )}
              </span>
            </Navbar.Brand>
            {showNavMenu && sessionStorage.getItem('reg') === 'true' && (
              <ShowIf isLoggedIn>
                <Nav.Link className="NavLink-push-left" as={RouterLink} to="/main" style={{ marginBottom: '1.6rem' }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ width: '1.3rem', color: navbarFontColour }}
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M15.45,7L14,5.551V2c0-0.55-0.45-1-1-1h-1c-0.55,0-1,0.45-1,1v0.553L9,0.555C8.727,0.297,8.477,0,8,0S7.273,0.297,7,0.555  L0.55,7C0.238,7.325,0,7.562,0,8c0,0.563,0.432,1,1,1h1v6c0,0.55,0.45,1,1,1h3v-5c0-0.55,0.45-1,1-1h2c0.55,0,1,0.45,1,1v5h3  c0.55,0,1-0.45,1-1V9h1c0.568,0,1-0.437,1-1C16,7.562,15.762,7.325,15.45,7z"
                      clipRule="evenodd"
                    />
                  </svg>
                </Nav.Link>
                <ShowIf
                  or={[
                    { department: 'OPS' },
                    { department: 'TRADER', role: 'SUPERUSER' },
                    { department: 'TRADER', role: 'STANDARD' },
                    { department: 'LSP' },
                    { department: 'WLP', role: 'STANDARD' },
                    { department: 'WLP', role: 'SUPERUSER' },
                    { department: 'QA' },
                  ]}
                >
                  <NavDropdown title="Create Load" id="basic-nav</svg>-dropdown">
                    <ShowIf or={[{ department: 'OPS' }, { department: 'QA' }]}>
                      <NavDropdown.Item as={RouterLink} to="/load" end onClick={resetLoad}>
                        Build your load
                      </NavDropdown.Item>
                      <NavDropdown.Item as={RouterLink} to="/load/import" onClick={resetLoad}>
                        Import your load
                      </NavDropdown.Item>
                      <NavDropdown.Item as={RouterLink} to="/load/cm8/client" onClick={resetLoad}>
                        CM8 load
                      </NavDropdown.Item>
                    </ShowIf>

                    <ShowIf
                      or={[
                        { department: 'TRADER', role: 'SUPERUSER' },
                        { department: 'TRADER', role: 'STANDARD' },
                        { department: 'LSP' },
                        { department: 'WLP', role: 'STANDARD' },
                        { department: 'WLP', role: 'SUPERUSER' },
                      ]}
                    >
                      <NavDropdown.Item as={RouterLink} to="/EpoExports">
                        <ShowIf or={[{ department: 'TRADER' }, { department: 'LSP' }, { department: 'WLP' }]}>
                          New Load
                        </ShowIf>
                        <ShowIf or={[{ department: 'CMT' }, { department: 'FIN' }]}>EPO</ShowIf>
                      </NavDropdown.Item>
                    </ShowIf>
                  </NavDropdown>
                </ShowIf>

                <ShowIf
                  or={[
                    { department: 'OPS' },
                    { department: 'TRADER' },
                    { department: 'LSP' },
                    { department: 'WLP' },
                    { department: 'QA' },
                    { department: 'CMT' },
                    { department: 'IT' },
                  ]}
                >
                  <NavDropdown title="View Loads">
                    <ShowIf or={[{ department: 'TRADER' }, { department: 'LSP' }, { department: 'WLP' }]}>
                      <NavDropdown.Item as={RouterLink} to="/epo/loads">
                        Loads
                      </NavDropdown.Item>
                    </ShowIf>
                    <ShowIf or={[{ department: 'OPS' }, { department: 'QA' }, { department: 'IT' }]}>
                      <NavDropdown.Item as={RouterLink} to="/cabie/loads">
                        CABIE Loads
                      </NavDropdown.Item>
                      <NavDropdown.Item as={RouterLink} to="/epo/loads">
                        EPO Loads
                      </NavDropdown.Item>
                    </ShowIf>
                  </NavDropdown>
                </ShowIf>

                <ShowIf
                  or={[
                    { department: 'OPS', role: 'SUPERUSER' },
                    { department: 'FIN' },
                    { department: 'IT', role: 'SUPERUSER' },
                    { department: 'WLP' },
                    { department: 'TRADER' },
                    { department: 'CMT' },
                    { department: 'QA', role: 'SUPERUSER' },
                  ]}
                >
                  <Nav.Link as={RouterLink} to="/ReportsList">
                    Reports
                  </Nav.Link>
                </ShowIf>

                <ShowIf
                  or={[
                    { department: 'OPS' },
                    { department: 'CMT' },
                    { department: 'QA' },
                    { department: 'FIN' },
                    { department: 'IT' },
                  ]}
                >
                  <NavDropdown title="Master Data" id="basic-nav-dropdown">
                    <ShowIf or={[{ department: 'OPS' }, { department: 'QA' }, { department: 'CMT' }]}>
                      <NavDropdown.Item as={RouterLink} to="/Neenor">
                        NeeNor
                      </NavDropdown.Item>
                    </ShowIf>
                    <ShowIf or={[{ department: 'OPS' }, { department: 'QA' }]}>
                      <NavDropdown.Item as={RouterLink} to="/Products">
                        Products
                      </NavDropdown.Item>
                    </ShowIf>
                    <ShowIf
                      or={[{ department: 'OPS' }, { department: 'CMT' }, { department: 'QA' }, { department: 'FIN' }]}
                    >
                      <NavDropdown.Item as={RouterLink} to="/BusinessPartners">
                        Business Partners
                      </NavDropdown.Item>
                    </ShowIf>
                    <ShowIf or={[{ department: 'OPS' }, { department: 'CMT' }, { department: 'QA' }]}>
                      <NavDropdown.Item as={RouterLink} to="/CommodityCodes">
                        Manage Commodity Codes
                      </NavDropdown.Item>
                      <NavDropdown.Item as={RouterLink} to="/customstech">
                        Customs Tech
                      </NavDropdown.Item>
                      <NavDropdown.Item as={RouterLink} to="/ipaffs">
                        IPAFFS Risk Categorisation
                      </NavDropdown.Item>
                      <NavDropdown.Item as={RouterLink} to="/orderformtable">
                        Order Form Rules
                      </NavDropdown.Item>
                    </ShowIf>
                    <ShowIf
                      or={[
                        { department: 'OPS', role: 'SUPERUSER' },
                        { department: 'QA', role: 'SUPERUSER' },
                        { department: 'CMT', role: 'SUPERUSER' },
                        { department: 'CMT', role: 'STANDARD' },
                      ]}
                    >
                      <NavDropdown.Item as={RouterLink} to="/Maintenance">
                        CABIE Codelists
                      </NavDropdown.Item>
                    </ShowIf>
                    <ShowIf or={[{ department: 'CMT' }, { department: 'IT' }]}>
                      <NavDropdown.Item as={RouterLink} to="/Compliance">
                        Compliance
                      </NavDropdown.Item>
                    </ShowIf>
                    <ShowIf
                      or={[{ department: 'OPS' }, { department: 'CMT' }, { department: 'QA' }, { department: 'IT' }]}
                    >
                      <NavDropdown.Item as={RouterLink} to="/SkillsMatrix">
                        Skills Matrix
                      </NavDropdown.Item>
                    </ShowIf>
                  </NavDropdown>
                </ShowIf>

                <ShowIf or={[{ department: 'WLP' }, { department: 'TRADER' }]}>
                  <Nav.Link
                    href="https://www.eori.uk/customs-knowledge/cabie"
                    target="_blank"
                    className="knowledge-base-link"
                    onClick={(e) => e.currentTarget.blur()}
                  >
                    Knowledge Base
                  </Nav.Link>
                </ShowIf>

                <ShowIf
                  or={[
                    { department: 'OPS' },
                    { department: 'TRADER' },
                    { department: 'LSP' },
                    { department: 'WLP' },
                    { department: 'QA' },
                  ]}
                >
                  <NavDropdown title="Tools" id="basic-nav-dropdown">
                    <ShowIf
                      or={[
                        { department: 'TRADER' },
                        { department: 'OPS' },
                        { department: 'CMT' },
                        { department: 'LSP' },
                        { department: 'WLP' },
                        { department: 'QA' },
                      ]}
                    >
                      <NavDropdown.Item as={RouterLink} to="/DataValidation">
                        Tariff Tool
                      </NavDropdown.Item>
                      <ShowIf
                        or={[{ department: 'OPS' }, { department: 'CMT' }, { department: 'LSP' }, { department: 'QA' }]}
                      >
                        <NavDropdown.Item as={RouterLink} to="/TaricTool">
                          TARIC Tool
                        </NavDropdown.Item>
                      </ShowIf>
                      <NavDropdown.Item
                        href="https://ec.europa.eu/taxation_customs/dds2/eos/rex_validation.jsp?Lang=en"
                        target="_blank"
                      >
                        REX Number Validation
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="https://view.officeapps.live.com/op/view.aspx?src=https://8001340.fs1.hubspotusercontent-na1.net/hubfs/8001340/BTOM_SPS_risk_categories_Nov23.xlsx"
                        target="_blank"
                      >
                        SPS Risk Checker
                      </NavDropdown.Item>
                    </ShowIf>
                  </NavDropdown>
                </ShowIf>

                <ShowIf
                  or={[
                    { department: 'CMT', role: 'SUPERUSER' },
                    { department: 'CMT', role: 'STANDARD' },
                    { department: 'FIN', role: 'SUPERUSER' },
                    { department: 'FIN', role: 'STANDARD' },
                    { department: 'OPS', role: 'SUPERUSER' },
                    { department: 'OPS', role: 'STANDARD' },
                    { department: 'WLP', role: 'SUPERUSER' },
                    { department: 'WLP', role: 'STANDARD', isAdmin: true },
                    { department: 'IT', role: 'SUPERUSER' },
                    { department: 'IT', role: 'STANDARD' },
                    { department: 'QA', role: 'SUPERUSER' },
                    { department: 'QA', role: 'STANDARD' },
                    { department: 'TRADER', role: 'SUPERUSER', isAdmin: true },
                  ]}
                >
                  <NavDropdown title="Admin">
                    <ShowIf isAdmin>
                      <NavDropdown.Item as={RouterLink} to="/UserAdmin">
                        User Admin
                      </NavDropdown.Item>
                    </ShowIf>

                    <ShowIf or={[{ department: 'IT' }]}>
                      <NavDropdown.Item as={RouterLink} to="/OnBoarding">
                        Onboarding
                      </NavDropdown.Item>
                      <NavDropdown.Item as={RouterLink} to="/UserAdminAudit">
                        Audit
                      </NavDropdown.Item>
                    </ShowIf>
                    <ShowIf or={[{ department: 'IT' }]}>
                      <NavDropdown.Item as={RouterLink} to="/AppSettings">
                        App Settings
                      </NavDropdown.Item>
                    </ShowIf>
                    <ShowIf or={[{ department: 'IT' }, { department: 'CMT' }]}>
                      <NavDropdown.Item as={RouterLink} to="/UserAdminCommcodes">
                        Commodity Codes
                      </NavDropdown.Item>
                    </ShowIf>

                    <ShowIf
                      or={[
                        { department: 'CMT', role: 'SUPERUSER' },
                        { department: 'CMT', role: 'STANDARD' },
                      ]}
                    >
                      <NavDropdown.Item as={RouterLink} to="/Userprofile">
                        Company Profile
                      </NavDropdown.Item>
                    </ShowIf>
                    <ShowIf
                      or={[
                        { department: 'FIN', role: 'SUPERUSER' },
                        { department: 'FIN', role: 'STANDARD' },
                        { department: 'CMT', role: 'SUPERUSER' },
                        { department: 'CMT', role: 'STANDARD' },
                        { department: 'OPS', role: 'SUPERUSER' },
                        { department: 'OPS', role: 'STANDARD' },
                        { department: 'QA', role: 'SUPERUSER' },
                        { department: 'QA', role: 'STANDARD' },
                      ]}
                    >
                      <NavDropdown.Item as={RouterLink} to="/EpoApplications">
                        EPO Applications
                      </NavDropdown.Item>
                    </ShowIf>
                    <ShowIf or={[{ department: 'WLP', role: 'SUPERUSER' }]}>
                      <NavDropdown.Item as={RouterLink} to="/WlpTrader">
                        Traders
                      </NavDropdown.Item>
                    </ShowIf>
                    <ShowIf
                      or={[
                        { department: 'OPS', role: 'SUPERUSER' },
                        { department: 'WLP', role: 'SUPERUSER' },
                        { department: 'QA', role: 'SUPERUSER' },
                      ]}
                    >
                      <NavDropdown.Item as={RouterLink} to="/Register">
                        Register Customer
                      </NavDropdown.Item>
                    </ShowIf>
                    <ShowIf or={[{ department: 'IT' }]}>
                      <NavDropdown.Item as={RouterLink} to="/MaintenanceBanner">
                        Maintenance Banner
                      </NavDropdown.Item>
                    </ShowIf>
                    <ShowIf
                      or={[
                        { department: 'OPS', role: 'SUPERUSER' },
                        { department: 'QA', role: 'SUPERUSER' },
                        { department: 'OPS', role: 'STANDARD' },
                      ]}
                    >
                      <NavDropdown.Item as={RouterLink} to="/UnmatchedDeclarations">
                        Unmatched Declarations
                      </NavDropdown.Item>
                    </ShowIf>
                  </NavDropdown>
                </ShowIf>

                <div style={{ flexGrow: 1 }} />
                <div className="gap-2 align-items-center d-flex" style={{ marginBottom: '2.3rem' }}>
                  <OverlayTrigger
                    placement="left"
                    trigger={['hover', 'focus']}
                    overlay={
                      <Popover
                        className="shadow"
                        style={{
                          minWidth: '320px',
                          padding: '10px',
                          paddingBottom: '1rem',
                        }}
                      >
                        <PopoverContent>
                          <h5>User Details</h5>
                          <hr />
                          <div>
                            <span className="cci-header" style={{ marginRight: '10px' }}>
                              Name:
                            </span>
                            <span className="pad-out">{sessionStorage.getItem('fullName')}</span>
                          </div>
                          <div>
                            <span className="cci-header" style={{ marginRight: '10px' }}>
                              Email:
                            </span>
                            <span className="pad-out">{sessionStorage.getItem('name')}</span>
                          </div>
                          <div>
                            <span className="cci-header" style={{ marginRight: '10px' }}>
                              Department:
                            </span>
                            <span className="pad-out">{sessionStorage.getItem('department')}</span>
                          </div>
                          <div>
                            <span className="cci-header" style={{ marginRight: '10px' }}>
                              Role:
                            </span>
                            <span className="pad-out">{sessionStorage.getItem('role')}</span>
                          </div>
                          <div>
                            <span className="cci-header" style={{ marginRight: '10px' }}>
                              Admin:
                            </span>
                            <span className="pad-out">
                              {JSON.parse(sessionStorage.getItem('admin')) ? 'Yes' : 'No'}
                            </span>
                          </div>
                          {JSON.parse(sessionStorage.getItem('trader')) && (
                            <div>
                              <span className="cci-header" style={{ marginRight: '10px' }}>
                                Trader:
                              </span>
                              <span className="pad-out">{sessionStorage.getItem('trader') ? 'Yes' : 'No'}</span>
                            </div>
                          )}
                          <div>
                            <span className="cci-header" style={{ marginRight: '10px' }}>
                              Last Logged in:
                            </span>
                            <span className="pad-out">{isoDateConverter(sessionStorage.getItem('lastLoggedIn'))}</span>
                          </div>
                        </PopoverContent>
                      </Popover>
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ width: '1.3rem', color: navbarFontColour }}
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </OverlayTrigger>
                </div>

                <Nav.Item style={{ marginRight: '1.3rem' }}>
                  <Nav.Link as={RouterLink} to="/logout" className="navbar-text">
                    Logout
                  </Nav.Link>
                </Nav.Item>
              </ShowIf>
            )}

            <ShowIf isLoggedIn={true}>
              {sessionStorage.getItem('reg') === 'false' && (
                <>
                  <div style={{ flexGrow: 1 }} />
                  <div className="gap-2 align-items-center d-flex" style={{ marginBottom: '2.4rem' }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ width: '1.3rem', color: navbarFontColour }}
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span
                      style={{
                        marginRight: '1rem',
                        fontSize: '1rem',
                        color: '#ffbe00',
                      }}
                    >
                      {sessionStorage.getItem('name')}
                    </span>
                  </div>

                  <Nav.Item style={{ marginRight: '1.3rem' }}>
                    <Nav.Link as={RouterLink} to="/logout" className="navbar-text">
                      Logout
                    </Nav.Link>
                  </Nav.Item>
                </>
              )}
            </ShowIf>
            <ShowIf isLoggedIn={false}>
              <div style={{ flexGrow: 1 }} />
              <div className="gap-2 align-items-center d-flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ width: '1.3rem', color: navbarFontColour }}
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                </svg>
                <Nav.Link
                  as={RouterLink}
                  to="/Login"
                  className="d-inline-flex align-items-center justify-content-center"
                  style={{ color: navbarFontColour }}
                >
                  Login
                </Nav.Link>
                <div
                  style={{
                    pointerEvents: 'none',
                    width: '0.01rem',
                    height: '0.9rem',
                    backgroundColor: navbarFontColour,
                  }}
                  className="rounded"
                >
                  &nbsp;
                </div>
                <Nav.Link
                  as={RouterLink}
                  to="/Register"
                  className="d-inline-flex gap-2 align-items-center justify-content-center"
                  style={{ color: navbarFontColour }}
                >
                  Signup
                </Nav.Link>
              </div>
            </ShowIf>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default NavbarMenu;
